<script lang="ts" module>
    export const addDebug = addToPanel;
    export function debugWidget<T extends Props[typeof TYPE]>(
        type: T,
        value: Omit<Props & { [TYPE]: T }, typeof TYPE>,
    ) {
        return { ...value, [TYPE]: type };
    }
</script>

<script lang="ts">
    import { debug, useLocalStorage } from "../../local-storage.svelte.js";
    import { Inspect, addComponent, addToPanel, type CustomComponents, type PanelSettings } from "svelte-inspect-value";
    import DebugWidget, { TYPE, type Props } from "./debug-widget.svelte";
    import { z } from "@repo/utils";
    import DebugBigNumber from "./debug-bignumber.svelte";
    import { RenderScan } from "svelte-render-scan";

    const ls = useLocalStorage("inspect", { settings: z.custom<Partial<PanelSettings>>() });
    const customComponents: CustomComponents = $derived({
        object: addComponent(
            DebugWidget,
            (x: any) => x.value,
            (x: any) => typeof x.value[TYPE] === "string",
        ),
        bignumber: addComponent(DebugBigNumber),
    });

    $effect(() => {
        function fn(ev: KeyboardEvent) {
            if (ev.code === "KeyK" && ev.ctrlKey && ev.altKey && ev.metaKey) {
                debug.enabled = !debug.enabled;
            }
        }
        document.addEventListener("keydown", fn);
        return () => {
            document.removeEventListener("keydown", fn);
        };
    });
</script>

{#if debug.enabled}
    <Inspect.Panel open {customComponents} onSettingsChange={x => (ls.settings = x)} {...ls.settings} />
    <RenderScan initialEnabled={false} />
{/if}
